import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { MUNICIPALITY_MILANO } from 'civil-status/constants/municipality-milano';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export const IdOtherMunicipalityFormation = '0';

interface ListMunicipalityFormationProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
  required?: boolean;
  isWithIstat?: boolean;
}

const ListMunicipalityFormationComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Comune di formazione',
  required,
  isWithIstat,
}: ListMunicipalityFormationProps): React.ReactElement => {
  const listData: Array<ItemVM> = useMemo(() => {
    return [
      {
        id: '',
        value: 'Nessuno',
      },
      {
        id: isWithIstat
          ? MUNICIPALITY_MILANO.istatCode || ''
          : MUNICIPALITY_MILANO.istatCode?.toString() || '',
        value: 'Milano',
      },
      {
        id: IdOtherMunicipalityFormation,
        value: 'Altri comuni',
      },
    ];
  }, [isWithIstat]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel id="municipality-formation-list-label">{`${label} ${
        required ? '*' : ''
      }`}</InputLabel>
      <PmiSelect
        labelId="municipality-formation-list-label"
        id="municipality-formation-list"
        name="municipality-formation-list"
        value={value}
        label={`${label} ${required ? '*' : ''}`}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {listData?.map((state: ItemVM) => (
          <MenuItem key={state.id} value={state.id}>
            {state.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListMunicipalityFormationComponent.displayName = 'List Municipality Formation component';

const ListMunicipalityFormation = memo(ListMunicipalityFormationComponent);

export default ListMunicipalityFormation as typeof ListMunicipalityFormationComponent;
